import React, { useEffect, useState } from "react"
import { mapTableRows } from "../../../../../utils";
import { Button, CopyToClipboard, LogoLoader, Modal, NewTableAdv, SmartTooltip, TableAdv } from "../../../../../components";
import AddContactModal from "../../Modals/AddContactModal";
import EditContactModal from "../../Modals/EditContactModal";
import { getLeadContacts } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";

const OtherContacts = ({companyUiid}) => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openContactModal, setOpenContactModal] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);
    const [openEditContactModal,setOpenEditContactModal] = useState(false);
    const dispatch = useDispatch();
    const { page, limit, setPage, handleLimitChange } = usePagination(
            10,
            (newPage, newLimit) => {}
          );
    const { value } = useSelector((state) => state?.totalCount);
    const totalCount = value?.LeadCompanyContactCnt?.data || 0;
    const columns = [
        {
            key: "id",
            label: "ID",
        },
        // {
        //     key: "source",
        //     label: "Source",
        // },
        {
            key: "firstName",
            label: "First Name",
        },
        {
            key: "lastName",
            label: "Last Name",
        },
        {
            key: "mobile",
            label: "Mobile",
        },
        {
            key: "email",
            label: "Email",
            render: (row) => (
                <div className="flex items-center">
                    <CopyToClipboard
                        title={
                            row?.email
                        }
                        content={
                            row?.email
                        }
                    />
                    {row?.email}
                </div>
            ),
        },
        // {
        //     key: "emailStatus",
        //     label: "Email Status",
        // },
        // {
        //     key: "jobTitle",
        //     label: "Job Title",
        //     render: (row) => (
        //         <Button
        //             type="icon"
        //             color="info"
        //             icon="open_in_new"
        //             variant="text"
        //             size="sm"
        //             onClick={() => window.open(row.url, "_blank")}
        //         />
        //     ),
        // },
        {
            key: "",
            label: "Action",
            align: "right",
            render: (row) => (
                <SmartTooltip description={"Edit"} tooltipPosition="left" noicon>
                    <Button
                        type="icon"
                        color="blue"
                        icon="edit_square"
                        variant="text"
                        size="sm"
                        onClick={() => {
                            setSelectedContact(row.original);
                            setOpenEditContactModal(true)
                        }}
                    />
                </SmartTooltip>
            ),
        },
    ];
    // const rows = [
    //     {
    //         id: "OC-001",
    //         source: "LinkedIn",
    //         firstName: "Amit",
    //         lastName: "Sharma",
    //         mobile: "+91 9876543210",
    //         email: "amit.sharma@company.com",
    //         emailStatus: "Verified",
    //         jobTitle: "HR Manager",
    //     },
    //     {
    //         id: "OC-002",
    //         source: "Referral",
    //         firstName: "Neha",
    //         lastName: "Verma",
    //         mobile: "+91 9123456789",
    //         email: "neha.verma@company.com",
    //         emailStatus: "Pending",
    //         jobTitle: "Talent Acquisition Lead",
    //     },
    //     {
    //         id: "OC-003",
    //         source: "Website",
    //         firstName: "Rohit",
    //         lastName: "Singh",
    //         mobile: "+91 9988776655",
    //         email: "rohit.singh@company.com",
    //         emailStatus: "Bounced",
    //         jobTitle: "Hiring Manager",
    //     },
    //     {
    //         id: "OC-004",
    //         source: "Cold Call",
    //         firstName: "Pooja",
    //         lastName: "Nair",
    //         mobile: "+91 9012345678",
    //         email: "pooja.nair@company.com",
    //         emailStatus: "Verified",
    //         jobTitle: "HR Business Partner",
    //     },
    // ];
    const rows = contacts.map((item) => ({
        original: item,
        id: item?.uiid || "-",
        source: item?.source || "-",
        firstName: item?.firstName || "-",
        lastName: item?.lastName || "-",
        mobile: item?.mobile?.number
          ? `${item?.mobile?.code} ${item?.mobile?.number}`
          : "-",
        email: item?.email || "-",
        emailStatus: item?.emailStatus || " ",
        url: item?.url || "-",
    }));

    const mappedRows = mapTableRows(rows, columns);
    const fetchContacts = async () => {
        try {
            setLoading(true);
            const params = {
                coll: "LeadContact",
                ret: "uiid source firstName lastName mobile email emailStatus url websiteUrl designation emailStatus",
                fil: JSON.stringify({
                    companyId: { type: "NONE", value: companyUiid },
                    isClient: { type: "NONE", value: false },
                    isPrimary: { type: "NONE", value: false }
                }),
                lim: limit,
                pg: page
            }
            const res = await getLeadContacts(params);

            setContacts(res?.data?.data || []);
        } catch (err) {
            console.error("Failed to fetch other contacts", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!companyUiid) return;
        dispatch(
        totalCountStart({
            collection: "leadcontacts",
            coll: "LeadContact",
            tname: "LeadCompanyContactCnt",
            app: "ats",
            filters:{
                companyId: { type: "NONE", value: companyUiid },
                isClient: { type: "NONE", value: false },
                isPrimary: { type: "NONE", value: false },
            },
        })
        );

        fetchContacts();
    }, [companyUiid,limit, page]);
    if (loading) {
    return (
        <div className="flex items-center justify-center h-64">
        <LogoLoader />
        </div>
    );
    }


    return (
        <div>
            <TableAdv
                tableId={`ats_priorityleads_leadview_othercontacts_table`}
                columns={columns}
                rows={mappedRows}
                serverPagination={true}
                totalCount={totalCount}
                page={page}
                limit={limit}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                toolbarRight={{
                    search: true,
                    fullScreen: true,
                    add: [

                        {
                            component: (
                                <>
                                    <Button
                                        title="Add Contact"
                                        size="sm"
                                        icon="add"
                                        onClick={() => setOpenContactModal(true)}
                                    />
                                </>
                            ),
                        },
                    ],
                }}
            />
            <Modal
                isOpen={openContactModal}
                onClose={() => setOpenContactModal(false)}
                title={"Add Contact"}
                titleColor={"primary"}
                width="max-w-5xl"
            >
                <AddContactModal
                    onCancel={() => setOpenContactModal(false)}
                    companyUiid={companyUiid}
                    onSuccess={() => {
                        dispatch(
                        totalCountStart({
                            collection: "leadcontacts",
                            coll: "LeadContact",
                            tname: "LeadCompanyContactCnt",
                            app: "ats",
                            filters:{
                                companyId: { type: "NONE", value: companyUiid },
                                isClient: { type: "NONE", value: false },
                                isPrimary: { type: "NONE", value: false }
                            },
                        })
                        );
                        fetchContacts();
                    }}
                    
                />
            </Modal>
            <Modal
                isOpen={openEditContactModal}
                onClose={() => setOpenEditContactModal(false)}
                title={"Edit"}
                titleColor={"primary"}
                width="max-w-5xl"
            >
                <EditContactModal
                    data={selectedContact}
                    onCancel={() => setOpenEditContactModal(false)}
                    onSuccess={() => {
                        setOpenEditContactModal(false);
                        fetchContacts();
                    }}
                />
            </Modal>
        </div>
    )
}
export default OtherContacts;